import { Cookies } from 'react-cookie';
import moment from 'moment';
import runtimeConfig from '../config/runtimeConfig';
import api from '../api';
import lct from '../helpers/location';
import UserStore from '../stores/UserStore';

const cookOptions = {path: '/'};
const cookies = new Cookies();
const nameCookieLastTimeUpdateRefreshToken = 'b4250c462007ab4e646a8e1faf2e5cc5';
const ignoreIntervalUpdateToken = 1800; // seconds
let AccessTokenIsDeleted = false;

const _getCurrentTimeInUtc = () => {
    return moment.utc().unix();
};

const _getLastUpdateTime = () => {
    return cookies.get(nameCookieLastTimeUpdateRefreshToken) || 0;
};

const _checkUpdateTokenForwarding = () => {
    let cutTime = _getCurrentTimeInUtc();
    let lastUpdateTime = _getLastUpdateTime();
    let deltaTime = cutTime - lastUpdateTime;

    return lastUpdateTime && deltaTime <= ignoreIntervalUpdateToken && deltaTime >= 0;
};

const SessionActions = {
    authorize(success, loading) {
        const hashData = lct.parse(window.location.hash);
        const accessDate = cookies.get(runtimeConfig.nameCookie);
        const isAccessTokenHash = hashData.access_token;
        const isImpersonatingUser = hashData.impersonating_user || accessDate && accessDate.impersonating_user;

        if (isImpersonatingUser) {
            UserStore.setImpersonating(isImpersonatingUser);
        }

        if (!isAccessTokenHash && !accessDate) {
            SessionActions.getAccessToken();
        } else {
            if (isAccessTokenHash) {
                hashData.createdCookTime = _getCurrentTimeInUtc();
                cookies.set(runtimeConfig.nameCookie, hashData, cookOptions);
            }

            if (SessionActions.authentication()) {
                success();
                SessionActions.updateRefreshToken();
            } else {
                loading();
                SessionActions.updateRefreshToken(success);
            }
        }

        window.location.hash && (window.location.hash = '');
    },

    deleteAccessToken() {
        AccessTokenIsDeleted = true;
        cookies.remove(runtimeConfig.nameCookie, cookOptions);
        cookies.remove(nameCookieLastTimeUpdateRefreshToken, cookOptions);
    },

    getAccessToken() {
        if (!AccessTokenIsDeleted) {
            api.getAccessToken();
        }
    },

    saveAccessData(accessData = {}) {
        let oldAccessData = SessionActions.getAccessData();

        accessData = {
            ...oldAccessData,
            ...accessData,
            impersonating_user: UserStore.getImpersonating()
        };

        cookies.set(runtimeConfig.nameCookie, accessData, cookOptions);
    },

    getAccessData() {
        return cookies.get(runtimeConfig.nameCookie) || {};
    },

    updateRefreshToken(callback) {
        let accessData = SessionActions.getAccessData();
        let params = {
            refresh_token: accessData.refresh_token,
            client_id: runtimeConfig.clientId
        };

        if (!params.refresh_token) {
            SessionActions.getAccessToken();
        }

        if (_checkUpdateTokenForwarding()) {
            setTimeout(SessionActions.updateRefreshToken, SessionActions.getTimeUpdateRefreshToken());

            callback && callback();
        } else {
            cookies.set(nameCookieLastTimeUpdateRefreshToken,  _getCurrentTimeInUtc(), cookOptions);

            api.updateRefreshToken(params).then((resp) => {
                SessionActions.saveAccessData(resp);

                setTimeout(SessionActions.updateRefreshToken, SessionActions.getTimeUpdateRefreshToken());

                callback && callback();
            }).catch(() => {
                SessionActions.getAccessToken();
            });
        }
    },

    authentication() {
        let data = SessionActions.getAccessData();
        let cutTime = _getCurrentTimeInUtc();
        let deltaTime = data.expires_at - data.created_at;
        let lastUpdateTime = _getLastUpdateTime();

        return cutTime < lastUpdateTime + deltaTime;
    },

    getTimeUpdateRefreshToken() {
        let data = SessionActions.getAccessData();
        let deltaTime = data.expires_at - data.created_at;

        return deltaTime * runtimeConfig.percentTimeUpdateToken * 1000;
    },

    saveUserID() {
        let accessData = SessionActions.getAccessData();
        accessData.userID = UserStore.getID();

        SessionActions.saveAccessData(accessData);
    },

    userAuthentication() {
        const accessData = SessionActions.getAccessData();

        if (accessData.userID && UserStore.getID() && accessData.userID !== UserStore.getID()) {
            window.location.reload();
        }
    },

    isLoopToken() {
        return SessionActions.getAccessData().createdCookTime === _getCurrentTimeInUtc();
    },
};

export default SessionActions;
